"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gqlGetTournamentRatings = exports.gqlGetAllTournaments = void 0;
var getAllTournaments_1 = require("./getAllTournaments");
Object.defineProperty(exports, "gqlGetAllTournaments", { enumerable: true, get: function () { return __importDefault(getAllTournaments_1).default; } });
var getTournamentRatings_1 = require("./getTournamentRatings");
Object.defineProperty(exports, "gqlGetTournamentRatings", { enumerable: true, get: function () { return __importDefault(getTournamentRatings_1).default; } });
